.bowo0c0 {
  display: flex;
  align-items: center;
}
.bowo0c1 {
  transition: var(--_8gdnqx14);
  display: inline;
  cursor: pointer;
}
.bowo0c2 {
  font-size: var(--_8gdnqx9);
  position: relative;
}
.bowo0c3 {
  color: var(--_8gdnqx5f);
}
.bowo0c3:hover {
  color: var(--_8gdnqx5g);
}
.bowo0c4 {
  color: var(--_8gdnqx5h);
}
.bowo0c4:hover {
  color: var(--_8gdnqx5i);
}
.bowo0c5 {
  text-decoration: underline;
}
.bowo0c6 {
  text-decoration: none;
}
.bowo0c7 {
  font-size: var(--_8gdnqx4);
}
.bowo0c8 {
  font-size: var(--_8gdnqx5);
}